import { render, staticRenderFns } from "./LayoutVerticalContentRenderer.vue?vue&type=template&id=c208315e&"
import script from "./LayoutVerticalContentRenderer.vue?vue&type=script&lang=js&"
export * from "./LayoutVerticalContentRenderer.vue?vue&type=script&lang=js&"
import style0 from "./LayoutVerticalContentRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports